import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import GroheCartConfirmHeader from "./groheCartConfirmHeader";
import GroheCartContent from "../groheCartContent";
import MaterialSpinner from "../../../../ui/materialSpinner";
import Button from "@mui/material/Button";

import {ROUTES} from "../../../../../routes";
import {cartItemInStock, filterCartItems} from "../../../lookNavigation/lookFunctions2";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import GroheCartBackButton from "../groheCartBackButton";
import WithCartCheckoutClick from "../../../hocs/withCartCheckoutClick";
import useUpdateSureTax from "../../../hooks/useUpdateSureTax";
// import {QuoteRequestType} from "../../../../visComponents/constants";


const GroheCartConfirm = (props) => {

  const {visualizersLoadedLength, isMobile, cartItems, history, fabricatorSettings, cartCheckoutClick} = props;

  const buttonTranslate = fabricatorSettings.useShipping ? "buttons.next" : "grohe.cart.confirm.checkoutButton";

  useUpdateSureTax(visualizersLoadedLength, cartItems);

  const backButtonClick = () => {
    if (fabricatorSettings.hasPaymentGateway) {
      history.push(ROUTES.cartBilling);
    } else {
      history.push(ROUTES.cart);
    }
  };

  const cartItemsToInclude = filterCartItems(cartItems);

  const disabled = cartItemsToInclude.every(cartItem => !cartItemInStock(cartItem))
    || cartItemsToInclude.filter(cartItem => cartItemInStock(cartItem)).every(cartItem => !cartItem.quantity);

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: backButtonClick
    },
    {
      translate: buttonTranslate,
      classes: "look-button--blue gc-sticky__button--60",
      onClick: cartCheckoutClick,
      disabled
    }
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartConfirmHeader/>
        {visualizersLoadedLength ? <GroheCartContent/> : (
          <div className="gc-main">
            <MaterialSpinner/>
          </div>
        )}
        {isMobile ? (
          <Fragment>
            <div className="gc-spacer"/>
            {/*<div className="gc-spacer gc-spacer--small"/>*/}
          </Fragment>
        ) : (
          <footer className="gc-footer">
            <div className="gc-form__submit-right">
              <GroheCartBackButton backButtonClick={backButtonClick}/>
              <Button className={"look-button look-button--blue look-button--big nowrap"
                + (fabricatorSettings.useShipping ? " look-button--large" : "")}
                      disabled={disabled}
                      onClick={cartCheckoutClick}>
                <FormattedMessage id={buttonTranslate}/>
              </Button>
            </div>
          </footer>
        )}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, isMobile} = store.serverState;
  const {cartItems, sureTax} = store.cartState;
  const {settings} = store.fabricatorState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    isMobile,
    cartItems,
    sureTax,
    fabricatorSettings: settings,
  };
};

export default withRouter(
  connect(mapStateToProps)(WithCartCheckoutClick(GroheCartConfirm))
)
